export const allInUnion =
  <T>() =>
  <U extends Array<T>>(
    array: U & ([T] extends [U[number]] ? unknown : "Invalid type")
  ) =>
    array;
